import PropTypes from 'prop-types';
import { useEffect } from 'react';
import classes from './layoutWrapper.module.css';

// TODO: why we need this component?

const LayoutWrapper = ({ children, sideSize = 'md' }) => {
  useEffect(() => {
    if (sideSize) {
      document.documentElement.style.setProperty('--current-side-size', `var(--page-size-${sideSize})`);
    }
    return () => {
      document.documentElement.style.removeProperty('--current-side-size');
    };
  }, [sideSize]);

  return (
    <div className={classes.wrapper} data-side-size={sideSize}>
      {children}
    </div>
  );
};

LayoutWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  sideSize: PropTypes.oneOf(['sm', 'md', 'lg']),
};

export default LayoutWrapper;
